import { call, put } from "redux-saga/effects";
import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

import Api from "common/api";
import constants from "./constants";

export default {
  showNoAdsToast: function* (data) {
    const __name = constants.SHOW_NO_ADS_TOAST;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  setGoogleUserInfo: function* (data) {
    const __name = constants.SET_GOOGLE_USER_INFO;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  setSyncedOfflineConversions: function* (data) {
    const __name = constants.SET_SYNCED_OFFLINE_CONVERSIONS;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  changeSettingPage: function* (data) {
    const __name = constants.CHANGE_SETTING_PAGE;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  getAccountHierarchy: function* (data) {
    const __name = constants.GET_ACCOUNT_HIERARCHY;
    try {
      console.log("getAccountHierarchy Data: ", data);
      const res = yield call(Api.getAccountHierarchy, data.token, data.params);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  getBusinessInfo: function* (data) {
    const __name = constants.GET_BUSINESS_INFO;
    try {
      console.log("getBusinessInfo Data: ", data);
      const res = yield call(Api.getBusinessInfo, data.token, data.params);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  getGoogleUserInfo: function* (data) {
    const __name = constants.GET_GOOGLE_USER_INFO;
    try {
      console.log("getGoogleUserInfo Data: ", data);
      const res = yield call(Api.getGoogleUserInfo, data.payload);
      console.log("getGoogleUserInfo Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  autoLinkAccount: function* (data) {
    const __name = constants.AUTO_LINK_ACCOUNT;
    try {
      console.log("autoLinkAccount Data: ", data);
      const res = yield call(Api.autoLinkAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setBusinessAdwordsId: function* (data) {
    const __name = constants.SET_BUSINESS_ADWORDS_ID;
    try {
      console.log("setBusinessAdwordsId Data: ", data);

      const res = yield call(Api.setBusinessAdwordsId, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setBusinessAdwordsName: function* (data) {
    const __name = constants.SET_BUSINESS_ADWORDS_NAME;
    try {
      console.log("setBusinessAdwordsName Data: ", data);
      const res = yield call(Api.setBusinessAdwordsName, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setBusinessCanAccess: function* (data) {
    const __name = constants.SET_BUSINESS_CAN_ACCESS;
    try {
      console.log("setBusinessCanAccess Data: ", data);
      const res = yield call(Api.setBusinessCanAccess, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getAdwordsConversionsData: function* (data) {
    const __name = constants.GET_ADWORDS_CONVERSIONS_DATA;
    try {
      console.log("getAdwordsConversionsData Data: ", data);
      const res = yield call(Api.getAdwordsConversionsData, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getAdwordsConversionsLastsend: function* (data) {
    const __name = constants.GET_ADWORDS_CONVERSIONS_LASTSEND;
    try {
      console.log("getAdwordsConversionsLastsend Data: ", data);
      const res = yield call(Api.getAdwordsConversionsLastsend, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setRwidgetConversionDefaultValue: function* (data) {
    const __name = constants.SET_RWIDGET_CONVERSION_DEFAULT_VALUE;
    console.log("in sagas rwidgetConversionDefaultValue");
    console.log(data);
    console.log("api url");
    console.log(Api.setRwidgetConversionDefaultValue);
    try {
      console.log("rwidgetConversionDefaultValue Data: ", data);
      const res = yield call(Api.setRwidgetConversionDefaultValue, data.params);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  createOfflineConversion: function* (data) {
    const __name = constants.CREATE_OFFLINE_CONVERSION;
    try {
      console.log("createOfflineConversion Data: ", data);
      const res = yield call(Api.createOfflineConversion, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getLinkAccountStatus: function* (data) {
    const __name = constants.GET_LINK_ACCOUNT_STATUS;
    try {
      console.log("getLinkAccountStatus Data: ", data);
      const res = yield call(Api.getLinkAccountStatus, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getBusinessPipelines: function* (data) {
    const __name = constants.GET_BUSINESS_PIPELINES;
    try {
      console.log("getBusinessPipelines Data: ", data);
      const res = yield call(Api.getBusinessPipelines, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getBusinessSteps: function* (data) {
    const __name = constants.GET_BUSINESS_STEPS;
    try {
      console.log("getBusinessSteps Data: ", data);
      const res = yield call(Api.getBusinessSteps, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getLeadSteps: function* (data) {
    console.log("getLeadSteps saga data:");
    const __name = constants.GET_LEAD_STEPS;
    try {
      console.log("getLeadSteps Data: ", data);
      const res = yield call(Api.getLeadSteps, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getAdwordsPipelineConversionsData: function* (data) {
    const __name = constants.GET_ADWORDS_PIPELINE_CONVERSIONS_DATA;
    try {
      console.log("getAdwordsPipelineConversionData Data: ", data);
      const res = yield call(Api.getAdwordsPipelineConversionsData, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  createAdwordsPipelineConversionsData: function* (data) {
    const __name = constants.CREATE_ADWORDS_PIPELINE_CONVERSIONS_DATA;
    try {
      console.log("createAdwordsPipelineConversionData Data: ", data);
      const res = yield call(Api.createAdwordsPipelineConversionsData, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getAccountData: function* (data) {
    const __name = constants.GET_ACCOUNT_DATA;
    try {
      console.log("getAccountData Data: ", data);
      const res = yield call(Api.getAccountData, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getOfflineConversionAddon: function* (data) {
    const __name = constants.GET_OFFLINE_CONVERSION_ADDON;
    try {
      console.log("getOfflineConversionAddon Data: ", data);
      const res = yield call(Api.getOfflineConversionAddon, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  updateOfflineConversionAddon: function* (data) {
    const __name = constants.UPDATE_OFFLINE_CONVERSION_ADDON;
    try {
      console.log("updateOfflineConversionAddon Data: ", data);
      const res = yield call(Api.updateOfflineConversionAddon, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getGoogleSheetsList api
   * @param {*} data
   */
  getGoogleSheetsList: function* (data) {
    const __name = constants.GET_GOOGLE_SHEETS_LIST;
    try {
      const res = yield call(Api.getGoogleSheetsList, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getGoogleExchangeToken api
   * @param {*} data
   */
  getGoogleExchangeToken: function* (data) {
    const __name = constants.GET_GOOGLE_EXCHANGE_TOKEN;
    try {
      const res = yield call(Api.getGoogleExchangeToken, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call setGoogleAccount api
   * @param {*} data
   */
  setGoogleAccount: function* (data) {
    const __name = constants.SET_GOOGLE_ACCOUNT;
    try {
      const res = yield call(Api.setGoogleAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call get google account api
   * @param {*} data
   */
  getGoogleAccount: function* (data) {
    const __name = constants.GET_GOOGLE_ACCOUNT;
    try {
      const res = yield call(Api.getGoogleAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call setGoogleSheetsSetting api
   * @param {*} data
   */
  setGoogleSheetsSetting: function* (data) {
    const __name = constants.SET_GOOGLE_SHEETS_SETTING;
    try {
      const res = yield call(Api.setGoogleSheetsSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleAdsLeadForm api
   * @param {*} data
   */
  getGoogleAdsLeadForm: function* (data) {
    const __name = constants.GET_GOOGLE_ADS_LEAD_FORM;
    try {
      const res = yield call(Api.getGoogleAdsLeadForm, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * change google ads form select type
   * @param {*} data
   */
  changeGoogleAdsFormSelectType: function* (data) {
    const __name = constants.CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set checked google ads form items
   * @param {*} data
   */
  setCheckedGoogleAdsFormItems: function* (data) {
    const __name = constants.SET_CHECKED_GOOGLE_ADS_FORM_ITEMS;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google connected
   * @param {*} data
   */
  setGoogleLeadGoogleConnected: function* (data) {
    const __name = constants.SET_GOOGLE_LEAD_GOOGLE_CONNECTED;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google disconnected
   * @param {*} data
   */
  setGoogleLeadGoogleDisconnected: function* (data) {
    const __name = constants.SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * change sheets url input
   * @param {*} data
   */
  changeGoogleLeadSheetsUrlInput: function* (data) {
    const __name = constants.CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call setGoogleAdsLeadFormSetting api
   * @param {*} data
   */
  setGoogleAdsLeadFormSetting: function* (data) {
    const __name = constants.SET_GOOGLE_ADS_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.setGoogleAdsLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call setGoogleSheetsGGLeadsSetting api
   * @param {*} data
   */
  setGoogleSheetsGGLeadsSetting: function* (data) {
    const __name = constants.SET_GOOGLE_SHEETS_GG_LEADS_SETTING;
    try {
      const res = yield call(Api.setGoogleSheetsGGLeadsSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getAllGoogleLeadFormSettings api
   * @param {*} data
   */
  getAllGoogleLeadFormSettings: function* (data) {
    const __name = constants.GET_ALL_GOOGLE_LEAD_FORM_SETTINGS;
    try {
      const res = yield call(Api.getAllGoogleLeadFormSettings, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call switchGoogleLeadFormStatus api
   * @param {*} data
   */
  switchGoogleLeadFormStatus: function* (data) {
    const __name = constants.SWITCH_GOOGLE_LEAD_FORM_STATUS;
    try {
      const res = yield call(Api.switchGoogleLeadFormStatus, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call archiveGoogleLeadFormSetting api
   * @param {*} data
   */
  archiveGoogleLeadFormSetting: function* (data) {
    const __name = constants.ARCHIVE_GOOGLE_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.archiveGoogleLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleAdsSetting api
   * @param {*} data
   */
  getGoogleAdsSetting: function* (data) {
    const __name = constants.GET_GOOGLE_ADS_SETTING;
    try {
      const res = yield call(Api.getGoogleAdsSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleSheetsSetting api
   * @param {*} data
   */
  getGoogleSheetsSetting: function* (data) {
    const __name = constants.GET_GOOGLE_SHEETS_SETTING;
    try {
      const res = yield call(Api.getGoogleSheetsSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleLeadCRMSetting api
   * @param {*} data
   */
  getGoogleLeadCRMSetting: function* (data) {
    const __name = constants.GET_GOOGLE_LEAD_CRM_SETTING;
    try {
      const res = yield call(Api.getGoogleLeadCRMSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleLeadFormSetting api
   * @param {*} data
   */
  getGoogleLeadFormSetting: function* (data) {
    const __name = constants.GET_GOOGLE_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.getGoogleLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set validate google lead form
   * @param {*} data
   */
  setValidateGoogleLeadForm: function* (data) {
    const __name = constants.SET_VALIDATE_GOOGLE_LEAD_FORM;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set validate google sheets url
   * @param {*} data
   */
  setValidateGoogleSheetsUrl: function* (data) {
    const __name = constants.SET_VALIDATE_GOOGLE_SHEETS_URL;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set validate gg leads google sheets url
   * @param {*} data
   */
  setValidateGGLeadsGoogleSheetsUrl: function* (data) {
    const __name = constants.SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set duplicate google form
   * @param {*} data
   */
  setDuplicateGoogleForm: function* (data) {
    const __name = constants.SET_DUPLICATE_GOOGLE_FORM;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleSheetsOfflineConversionsValue api
   * @param {*} data
   */
  getGoogleSheetsOfflineConversionsValue: function* (data) {
    const __name = constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE;
    try {
      const res = yield call(Api.getGoogleSheetsOfflineConversionsValue, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call setGoogleSheetsOfflineConversionsValue api
   * @param {*} data
   */
  setGoogleSheetsOfflineConversionsValue: function* (data) {
    const __name = constants.SET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE;
    try {
      const res = yield call(Api.setGoogleSheetsOfflineConversionsValue, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleSheetsOfflineConversionsLastSent api
   * @param {*} data
   */
  getGoogleSheetsOfflineConversionsLastSent: function* (data) {
    const __name = constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_LAST_SENT;
    try {
      const res = yield call(Api.getGoogleSheetsOfflineConversionsLastSent, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  updateGGLeadFormSettingErrorStatus: function* (data) {
    const __name = constants.UPDATE_GG_LEAD_FORM_SETTING_ERROR_STATUS;
    try {
      const res = yield call(Api.updateGGLeadFormSettingErrorStatus, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set file info error
   */
  setFileInfoError: function* (data) {
    const __name = constants.SET_FILE_INFO_ERROR;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google loading
   * @param {*} data
   */
  setGoogleLoading: function* (data) {
    const __name = constants.SET_GOOGLE_LOADING;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set Google Sheets loading
   * @param {*} data
   */
  setGoogleSheetsLoading: function* (data) {
    const __name = constants.SET_GOOGLE_SHEETS_LOADING;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set Google Sheets error
   * @param {*} data
   */
  setGoogleSheetsError: function* (data) {
    const __name = constants.SET_GOOGLE_SHEETS_ERROR;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set Google Ads Loading
   * @param {*} data
   */
  setGoogleAdsLoading: function* (data) {
    const __name = constants.SET_GOOGLE_ADS_LOADING;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google connection loading
   * @param {*} data
   */
  setGGConnectionLoading: function* (data) {
    const __name = constants.SET_GG_CONNECTION_LOADING;
    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
